import { SelectCreatableInput } from '@core/components/Select';
import FornecedorApi from 'app/services/api/fornecedorApi';
import React from 'react';

const carregarFornecedor = async (query = '', page = 0) => {
  if (!!query && query.length < 3) {
    return [];
  }

  const response = await FornecedorApi.buscar({
    page,
    sort: 'pessoa.nome,asc',
    q: query?.length ? query : '',
  });
  if (response?.data && response.data.content) {
    return response.data.content;
  }
  return [];
};

const SelectFornecedor = ({
  fornecedor,
  handleBlur,
  touched,
  error,
  handleChange,
  label = 'Fornecedor',
  id = 'fornecedor.id',
  idObject = 'fornecedor',
  autoFocus,
  required,
  disabled,
  tamanhoMinimo = 3,
  maxLength = 100,
}) => {
  return (
    <SelectCreatableInput
      required={required}
      onBlur={handleBlur}
      touched={touched}
      error={error}
      label={label}
      id={id}
      value={{ ...fornecedor }}
      autoFocus={autoFocus}
      disabled={disabled}
      onChange={(value) => {
        const event = {
          target: {
            id: idObject,
            value: {
              id: value?.id,
              pessoa: {
                nome: value?.pessoa?.nome,
              },
            },
          },
        };

        handleChange(event);
      }}
      getOptionKey={(option) => {
        if (option) {
          return option?.id;
        }
        return '';
      }}
      getOptionLabel={(option) => {
        if (option) {
          return option?.pessoa?.nome;
        }
        return '';
      }}
      onClearInput={() => {
        handleChange({ target: { id: idObject, value: undefined } });
      }}
      fetchData={carregarFornecedor}
      createData={async (data) => {
        const response = await FornecedorApi.cadastrar({ pessoa: { nome: data, tipoPessoa: 'JURIDICA' } });
        const event = {
          target: {
            id: idObject,
            value: {
              id: response?.data?.id,
              pessoa: {
                nome: response?.data?.pessoa?.nome,
              },
            },
          },
        };

        handleChange(event);
      }}
      fetchOnFocus
      tamanhoMinimo={tamanhoMinimo}
      maxLength={maxLength}
    />
  );
};

export default SelectFornecedor;
